<template>
  <div class="about">
    <!-- <h1>This is the Activity page</h1> -->

    <div class="myheaderbar">
      <h1>ACTIVITY</h1>
    </div>

    <div class="columns">
      <div class="column is-third" style="margin: 1em;">

        <div class="tabs  is-centered is-boxed">
          <ul>    

            

            <li v-bind:class="{ 'is-active': selectedtab==='open' }" @click="onTabSelect('open')">
              <a>
                <span class="icon is-small"><i class="fas fa-image" aria-hidden="true"></i></span>
                <span>Upcomming</span>
              </a>
            </li>

            <li v-bind:class="{ 'is-active': selectedtab==='past' }" @click="onTabSelect('past')">
              <a>
                <span class="icon is-small"><i class="fas fa-file-alt" aria-hidden="true"></i></span>
                <span>Past</span>
              </a>
            </li>
          </ul>
        </div>

        <div v-if="selectedtab==='open'">
          
          <b-field>
            <h1><b>Today</b></h1>
          </b-field>

          <ListPanelToday/>
          <!-- <ListPanelFiltered :config="{'per': 'today', 'order': 'asc'}"  :per="'future'" :order="'asc'" /> -->

          <b-field>
            <h1><b>Open / Upcomming</b></h1>
          </b-field>

          <ListPanelOpen/>
          <!-- <ListPanelFiltered :config="{'per': 'future', 'order': 'asc'}"  :per="'future'" :order="'asc'" /> -->
          
        </div>

        <div v-if="selectedtab==='past'">

           <b-field>
            <h1><b>History</b></h1>
          </b-field>

          <ListPanelHistory/>
          <!-- <ListPanelFiltered :config="{'per': 'history', 'order': 'desc'}"  :per="'future'" :order="'asc'" /> -->
          <!-- <ListPanelFiltered periode="history" sort="desc" /> -->

        </div>


       
        
      </div>
      
      <div class="column"  style="margin: 1em;">
        
        <EditActivity/>

      </div>
    </div>




  </div>
</template>


<script>
  // import CardEdit from '@/components/main/activity/CardEdit.vue';
  import EditActivity from '@/components/main/activity/EditActivity.vue';
  
  import ListPanelHistory from '@/components/main/activity/ListPanelHistory.vue';
  import ListPanelOpen from '@/components/main/activity/ListPanelOpen.vue';
  import ListPanelToday from '@/components/main/activity/ListPanelToday.vue';
  // import ListPanelFiltered from '@/components/main/activity/ListPanelFiltered.vue';
  // import Calendar from '@/components/main/dashboard/Calendar.vue'

  import { mapGetters, mapActions } from 'vuex';

  export default {
    components: {
      // CardEdit,
      EditActivity,
      ListPanelHistory,
      ListPanelOpen,
      ListPanelToday,
      // ListPanelFiltered,
      // Calendar

    },
    data() {
        return  {
          selectedtab: "open",
          // seggroups: [
          //   {id:1, name:"Zlatí zákazníci"},
          //   {id:2, name:"Strieborní zákazníci"},
          //   {id:3, name:"Bronzoví zákazníci"}, 
          //   {id:4, name:"Zemiakoví zákazníci"}
          // ], 
          // selectedgroupid: null
        }
    },
    computed: {
    ...mapGetters(['getAccount']), //'selectedContact'
    },
    methods: {
      ...mapActions([]), //'addNewContact'
      onTabSelect (tabname) {
        this.selectedtab = tabname
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    .myheaderbar {
      height: 3em;
      line-height: 3em;
      background: lightgray;
      text-align: left;
      padding-left: 1em;
    }
    .mybuttons {
      justify-content: center;
    }

    .my-horizontal-right {
      display: right;
    }
</style>